import {styled} from "@mui/system";
import Colors from "../../../../../../general/constants/colors";
import BreakPoints from "../../../../../../general/constants/breakPoints";

export const SubMenuContainer = styled("div")({
	display: 'none',
	width: "max-content",
	backgroundColor: Colors.WHITE,
	boxShadow: '0px 15px 30px -10px rgba(0,11,48,0.2)',
	position: "absolute",
	top: '60px',
	borderRadius: '16px',
	zIndex: 1,
	[`@media (max-width: ${BreakPoints.TABLET_1024}px)`]: {
		top: '53px',
	},
	[`@media (min-width: ${BreakPoints.FHD_1920}px)`]: {
		top: '80px',
	},
})